import { useEventBus } from "./events.mjs";
var Topics = /* @__PURE__ */ ((Topics2) => {
  Topics2["AuthIdentity"] = "auth:identify";
  Topics2["AuthLogout"] = "auth:logout";
  Topics2["CartFetchCustomerCart"] = "cart:CustomerCart";
  Topics2["CartMerged"] = "cart:CartMerged";
  Topics2["CartPlaceOrder"] = "cart:placeOrder";
  Topics2["CartIsPlacingOrder"] = "cart:isPlacingOrder";
  Topics2["CartPlacingOrderError"] = "cart:placingOrderError";
  return Topics2;
})(Topics || {});
export const topics = {
  auth: {
    identify: "auth:identify" /* AuthIdentity */,
    logout: "auth:logout" /* AuthLogout */
  },
  cart: {
    fetchCustomerCart: "cart:CustomerCart" /* CartFetchCustomerCart */,
    cartMerged: "cart:CartMerged" /* CartMerged */,
    placeOrder: "cart:placeOrder" /* CartPlaceOrder */,
    isPlacingOrder: "cart:isPlacingOrder" /* CartIsPlacingOrder */,
    placingOrderError: "cart:placingOrderError" /* CartPlacingOrderError */
  }
};
export function useChannels() {
  const { emit, on, off } = useEventBus();
  return {
    subscribe: on,
    push: emit,
    unsubscribe: off
  };
}
